import React from "react"
import { useLocation } from "react-router-dom"

// Comps
import ParticipantSelector from "./components/ParticipantSelector"
import MyParticipantsSummary from "../MyParticipantsSummary"
import AllParticipantsSummary from "../AllParticipantsSummary"
import OrganizationLogo from "../../components/OrganizationLogo"

import styles from "../../styles/Sidebar-Staff.module.css"

export default function ParticipantSidebar() {
  const location = useLocation()
  const handleSummary = () => {
    const currentPath = location.pathname
    switch (currentPath) {
      case "/participant/list":
        return <AllParticipantsSummary />
      case "/my-participants":
        return <MyParticipantsSummary />
      default:
        return null
    }
  }
  return (
    <>
      <OrganizationLogo />
      {handleSummary()}
      <h2>Active Participants</h2>
      <ParticipantSelector />
    </>
  )
}
